//---------------------
// save current skills
//---------------------
export default function saveCurrentSkills(skills) {
  // ----------------------
  // check got skill array
  // ----------------------
  if (!Array.isArray(skills)) return null
  //--------------------------------------------------
  // create array with specified props for each skill
  //--------------------------------------------------
  const original_skills = skills.map((skill) => ({
    name: skill.name, // for debug only
    id: skill.id ? skill.id : null, // character skill id if existing
    ticks: skill.ticks,
    training: skill.training,
  }))
  return original_skills
}